import { EditorState } from 'prosemirror-state';

export function isInList(state: EditorState, options?: { types: string[] }) {
  const $head = state.selection.$head;
  for (let d = $head.depth; d > 0; d--) {
    if (
      (options?.types
        ? options.types
        : ['ordered_list', 'bullet_list', 'checkbox_list', 'list_item']
      ).includes($head.node(d).type.name)
    ) {
      return true;
    }
  }

  return false;
}
